import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const pagingInsureRecords = async (data: object) => {
  return await POST({ url: Api.insureRecords, data, showError: false })
}

// 去购买
export const buyInsurance = async (params: object) => {
  return await GET({
    url: Api.buyInsurance,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      // cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
